import { ButtonIconFile } from "#common/Buttons"
import ButtonIcon from "#common/buttons/ButtonIcon"
import PERMISOS from "#constants/perfiles"
import { COLOR_WHITE } from "#constants/Styles"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import useHasPermission from "#hooks/useHasPermission"
import { STATUS_COURSE } from "#training/constants"
import {
	UseTarjetaContext,
	UseTarjetaPdfContext,
} from "#training/contexts/contextsTarjeta"
import { UseReload, UseSetEdit } from "#training/redux/actions"
import { courseCollaboratorIdGet, courseCollaboratorIdPut } from "#training/services/Api"
import CancelRoundedIcon from "@mui/icons-material/CancelRounded"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import NotInterestedRoundedIcon from "@mui/icons-material/NotInterestedRounded"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import VerifiedSharpIcon from "@mui/icons-material/VerifiedSharp"
import { Stack } from "@mui/material"
import { ESTADO_CURSOS } from "Components/Capacitaciones/constants_capacitaciones"
import { useCallback, useEffect, useMemo } from "react"

const TarjetaButtons = () => {
	const {
		curso: { id, status, url_s3: link, category },
		curso,
		setOpenDialog,
		setNewStatus,
		// setPdf,
	} = UseTarjetaContext()
	const { setPdf, setCursoId } = UseTarjetaPdfContext()
	const reloadNow = UseReload()
	const setEdit = UseSetEdit()
	const { hasPermissionV2 } = useHasPermission()
	const { fetch: upload } = useApiSend(courseCollaboratorIdPut, { success: reloadNow })
	const { data, fetch: download } = useApi(courseCollaboratorIdGet, {
		autoFetch: false,
	})
	useEffect(() => {
		if (data) window.open(data, "_blank")
	}, [data])

	const isApproved = status === ESTADO_CURSOS.APROBADO
	const isCancel = status === ESTADO_CURSOS.CANCELADO
	const isCheck = status === ESTADO_CURSOS.REVISAR
	const hasLink = !!link
	const isRH = hasPermissionV2(PERMISOS.RH_ALL)
	const isSH = hasPermissionV2(PERMISOS.SEGURIDAD_HIGIENE) && category === "Plan Calidad"

	const openDialog = useCallback(
		(newStatus) => {
			setOpenDialog(true)
			setNewStatus(newStatus)
		},
		[setOpenDialog, setNewStatus]
	)
	const show_rh = isRH && !STATUS_COURSE.GET_EDIT.includes(status)
	const buttons = useMemo(
		() => [
			{
				title: "Mostrar PDF",
				show: hasLink && !isCancel,
				icon: PictureAsPdfIcon,
				onClick: () => {
					setCursoId(id)
					setPdf((pdf) => !pdf)
				},
			},
			{
				title: "Cancelar",
				show: show_rh,
				icon: NotInterestedRoundedIcon,
				onClick: () => openDialog(ESTADO_CURSOS.CANCELADO),
				action: ESTADO_CURSOS.CANCELADO,
			},
			{
				title: "Aprobar",
				show: (isRH || isSH) && isCheck,
				icon: VerifiedSharpIcon,
				onClick: () => openDialog(ESTADO_CURSOS.APROBADO),
				action: ESTADO_CURSOS.APROBADO,
			},
			{
				title: "Rechazar",
				show: (isRH || isSH) && isCheck,
				icon: CancelRoundedIcon,
				onClick: () => openDialog(ESTADO_CURSOS.RECHAZADO),
				action: ESTADO_CURSOS.RECHAZADO,
			},
			{
				title: "Editar",
				show: show_rh,
				icon: EditIcon,
				action: "editar",
				onClick: () => setEdit(curso),
			},
			{
				title: "Eliminar",
				show: isRH || isSH,
				icon: DeleteIcon,
				onClick: () => openDialog("eliminar"),
				action: "eliminar",
				// sx: { color: "red" },
			},
		],
		[
			curso,
			hasLink,
			id,
			isCancel,
			isCheck,
			isRH,
			isSH,
			openDialog,
			setCursoId,
			setEdit,
			setPdf,
			show_rh,
		]
	)
	const buttonUpload = useMemo(() => {
		return (
			<ButtonIconFile
				title="Subir pdf2"
				id={id}
				onChange={(event) => {
					handleFileUpload(id, event, upload)
				}}
				accept=".pdf"
				show={!isApproved && !isCancel}
				sx={{ color: COLOR_WHITE }}
			/>
		)
	}, [id, isApproved, isCancel, upload])

	const ButtonShow = useMemo(() => {
		const b = buttons.map((button) => {
			return (
				<ButtonIcon
					key={button.title + id}
					sx={{ color: COLOR_WHITE }}
					{...button}
					hidden={!button.show}
					icon={<button.icon />}
				/>
			)
		})
		b.unshift(buttonUpload)
		return b
	}, [buttonUpload, buttons, id])

	return (
		<Stack
			direction={"row"}
			spacing={2}
			alignItems={"center"}
			justifyContent="right"
			width="70%"
		>
			{ButtonShow}
		</Stack>
	)
}
export default TarjetaButtons
const handleFileUpload = (id, event, upload) => {
	const file = event.target.files[0]
	let formData = new FormData()
	formData.append("pdf", file)

	upload(id, formData, { upload_pdf: true })
}
